import React from "react";
import { connect } from 'react-redux';
import { notifyContentModerator } from 'src/legacy/redux/actions/search.jsx';
import Button from "src/components/button";
import styles from "./styles.module.scss";
import { localizedStrings } from 'src/localization';
import { toast } from "react-toastify";
import Toast from "src/components/toast";
import _ from "lodash";

class EmptyContentView extends React.Component {
  constructor(props) {
    super(props);
    this._handleSendNotification = this._handleSendNotification.bind(this);
    this.localizedSearch = localizedStrings.pages.search;
  }

  _handleSendNotification() {
    if (this.props.notifyContentModerator && !this.props.isNotifying) {
      this.props.notifyContentModerator(this.props.searchQuery)
        .then(() => {
          toast(<Toast.Sucess message={this.localizedSearch.empty_message.no_results.toast.notify_success} />);
        })
        .catch((error) => {
          toast(<Toast.Error message="Failed to send notification" />);
        });
    }
  }

  render() {
    return (
      <div className={styles.emptyMessageWrapper}>
        <div className={styles.emptyMessage}>
          <img
            src="/images/assets/empty_hand.svg"
            alt="empty"
            className={styles.emptyHand}
          />
          <h3 className={styles.noResult}>No results found!</h3>
          <p className={styles.noResultMessage}>
            Would you like to notify administrators to add new content for your query?
          </p>
          <Button
            text={this.props.isNotifying ? 'Notifying administrators' : 'Click here to notify'}
            variant="primary"
            icon="paperflite-tick"
            primary
            disabled={this.props.isNotifying}
            onClick={this._handleSendNotification}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const account = _.get(state, "accounts.item", {});
  const contentModerator = _.get(state, "legacyRootReducer.search.contentModerator", {});
  
  return {
    contentModerators: account.contentModerators,
    isNotifying: contentModerator.notifying || false,
    searchQuery: ownProps.searchQuery
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    notifyContentModerator: (query) => dispatch(notifyContentModerator(query))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmptyContentView);